import {useUserStore} from '@/stores/user'
import router from "@/router";
import request from "@/http/request";
import {ElMessage} from 'element-plus'
import useClipboard from 'vue-clipboard3'
import {cancelMonitoring} from "@/util/im";


export function common() {
    //返回首页
    const backHome = () => {
        router.push({path: "/index"});
    }
    //返回上一页
    const routerBack = () => {
        router.back()
    }
    //页面跳转
    const toPage = (path, needLogin = false) => {
        const store = useUserStore()
        if (!store.isLogin && needLogin) {
            toPage(`/login`)
            return;
        }
        if (path) {
            router.push({path})
        }
    }
    //获取全路径url
    const getFullUrl = (url) => {
        if (!url) return ''
        if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) return url
        let baseUrl = request.defaults.baseURL
        // baseUrl = baseUrl.substring(0, baseUrl.length - 1)
        return `${baseUrl}${url}`;
    }
    const getGameUrl = (url) => {
        if (!url) return '';
        return `${process.env.VUE_APP_GAME_APP_ICON_BASE_URL}/${url}`;
    }
    //打开新窗口
    const openWindow = (url) => {
        window.open(url, '_blank');
    }
    //退出登录
    const logout = () => {
        const store = useUserStore()
        // 清空登录信息
        store.imId.value = ''
        store.userId.value = ''
        store.userToken.value = ''
        store.user.value = {}
        store.imReady.value = false
        // cancelMonitoring()
        // store.setUserId('')
        // store.setUserToken('')
        // store.setUser({})
        //路由跳转
        router.push({
            path: '/index',
            replace: true
        })
    }

    //复制文本
    const copyText = async (val) => {
        if (!val) return ElMessage.error('没有需要复制的内容')
        const {toClipboard} = useClipboard()
        try {
            await toClipboard(val)
            ElMessage.success('复制成功~')
        } catch (e) {
            ElMessage.error('复制失败~')
        }
        // if (navigator.clipboard && navigator.permissions) {
        //     await navigator.clipboard.writeText(val)
        //     ElMessage.success('复制成功~')
        // } else {
        //     const textArea = document.createElement('textArea')
        //     textArea.value = val
        //     textArea.style.width = 0
        //     textArea.style.position = 'fixed'
        //     textArea.style.left = '-999px'
        //     textArea.style.top = '10px'
        //     textArea.setAttribute('readonly', 'readonly')
        //     document.body.appendChild(textArea)
        //
        //     textArea.select()
        //     document.execCommand('copy')
        //     document.body.removeChild(textArea)
        //     ElMessage.success('复制成功~')
        // }
    }
    //转为浮点数
    const formatDecimal = (value, decimal = 2) => {
        if (!value) return 0;
        const num = parseFloat(value);
        // 判断是否是有效数字
        if (isNaN(num)) return value;
        // 如果是整数，则直接返回原值
        if (Number.isInteger(num)) return num.toString()
        return num.toFixed(decimal);
    }
    //隐藏中间四位数
    const maskMiddle = (value, hideCount = 4) => {
        if (value == null) return '';
        const str = String(value);
        const len = str.length;
        if (hideCount <= 0 || hideCount >= len) return '*'.repeat(len);
        const left = Math.floor((len - hideCount) / 2);
        const right = len - hideCount - left;
        return str.slice(0, left) + '*'.repeat(hideCount) + str.slice(len - right);
    }
    //深度克隆
    const deepClone = (obj, cache = new WeakMap()) => {
        if (obj === null || typeof obj !== 'object') return obj;
        if (cache.has(obj)) return cache.get(obj);
        let clone;
        if (obj instanceof Date) {
            clone = new Date(obj.getTime());
        } else if (obj instanceof RegExp) {
            clone = new RegExp(obj);
        } else if (obj instanceof Map) {
            clone = new Map(Array.from(obj, ([key, value]) => [key, deepClone(value, cache)]));
        } else if (obj instanceof Set) {
            clone = new Set(Array.from(obj, value => deepClone(value, cache)));
        } else if (Array.isArray(obj)) {
            clone = obj.map(value => deepClone(value, cache));
        } else if (Object.prototype.toString.call(obj) === '[object Object]') {
            clone = Object.create(Object.getPrototypeOf(obj));
            cache.set(obj, clone);
            for (const [key, value] of Object.entries(obj)) {
                clone[key] = deepClone(value, cache);
            }
        } else {
            clone = Object.assign({}, obj);
        }
        cache.set(obj, clone);
        return clone;
    }
    const formatDate = (dateTime = null, formatStr = 'yyyy-mm-dd') => {
        let date
        // 若传入时间为假值，则取当前时间
        if (!dateTime) {
            date = new Date()
        }
        // 若为unix秒时间戳，则转为毫秒时间戳（逻辑有点奇怪，但不敢改，以保证历史兼容）
        else if (/^\d{10}$/.test(dateTime?.toString().trim())) {
            date = new Date(dateTime * 1000)
        }
        // 若用户传入字符串格式时间戳，new Date无法解析，需做兼容
        else if (typeof dateTime === 'string' && /^\d+$/.test(dateTime.trim())) {
            date = new Date(Number(dateTime))
        }
            // 处理平台性差异，在Safari/Webkit中，new Date仅支持/作为分割符的字符串时间
        // 处理 '2022-07-10 01:02:03'，跳过 '2022-07-10T01:02:03'
        else if (typeof dateTime === 'string' && dateTime.includes('-') && !dateTime.includes('T')) {
            date = new Date(dateTime.replace(/-/g, '/'))
        }
        // 其他都认为符合 RFC 2822 规范
        else {
            date = new Date(dateTime)
        }

        const timeSource = {
            'y': date.getFullYear().toString(), // 年
            'm': (date.getMonth() + 1).toString().padStart(2, '0'), // 月
            'd': date.getDate().toString().padStart(2, '0'), // 日
            'h': date.getHours().toString().padStart(2, '0'), // 时
            'M': date.getMinutes().toString().padStart(2, '0'), // 分
            's': date.getSeconds().toString().padStart(2, '0') // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        }

        for (const key in timeSource) {
            const [ret] = new RegExp(`${key}+`).exec(formatStr) || []
            if (ret) {
                // 年可能只需展示两位
                const beginIndex = key === 'y' && ret.length === 2 ? 2 : 0
                formatStr = formatStr.replace(ret, timeSource[key].slice(beginIndex))
            }
        }

        return formatStr
    }
    const timeFrom = (timestamp = null, format = 'yyyy-mm-dd') => {
        if (timestamp == null) timestamp = Number(new Date())
        timestamp = parseInt(timestamp)
        // 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
        if (timestamp.toString().length == 10) timestamp *= 1000
        let timer = (new Date()).getTime() - timestamp
        timer = parseInt(timer / 1000)
        // 如果小于5分钟,则返回"刚刚",其他以此类推
        let tips = ''
        switch (true) {
            case timer < 300:
                tips = '刚刚'
                break
            case timer >= 300 && timer < 3600:
                tips = `${parseInt(timer / 60)}分钟前`
                break
            case timer >= 3600 && timer < 86400:
                tips = `${parseInt(timer / 3600)}小时前`
                break
            case timer >= 86400 && timer < 2592000:
                tips = `${parseInt(timer / 86400)}天前`
                break
            default:
                // 如果format为false，则无论什么时间戳，都显示xx之前
                if (format === false) {
                    if (timer >= 2592000 && timer < 365 * 86400) {
                        tips = `${parseInt(timer / (86400 * 30))}个月前`
                    } else {
                        tips = `${parseInt(timer / (86400 * 365))}年前`
                    }
                } else {
                    tips = formatDate(timestamp, format)
                }
        }
        return tips
    }
    //获取账号类型
    const getGoodsTypeText = (type) => {
        let text
        switch (Number(type)) {
            case 0:
                text = '账号'
                break;
            case 1:
                text = '金币'
                break;
            default:
                text = '道具'
        }
        return text
    }
    //获取订单状态 订单状态 0/代付款 1/已付款 2/代换绑 3/已换绑 4/交易完成 5/已取消 6/售后
    const getOrderStatusText = (status) => {
        let text
        switch (Number(status)) {
            case 0:
                text = '待支付'
                break;
            case 1:
                text = '已付款'
                break;
            case 2:
                text = '待换绑'
                break;
            case 3:
                text = '已换绑'
                break;
            case 4:
                text = '已完成'
                break;
            case 5:
                text = '已取消'
                break;
            default:
                text = '售后'
        }
        return text
    }
    //开发中提示
    const develop = () => {
        return ElMessage.success('功能开发中~')
    }
    return {
        backHome,
        routerBack,
        toPage,
        getFullUrl,
        getGameUrl,
        openWindow,
        logout,
        copyText,
        formatDecimal,
        maskMiddle,
        deepClone,
        formatDate,
        timeFrom,
        getGoodsTypeText,
        getOrderStatusText,
        develop,
    }
}
